import request from '@/utils/request';
import { errorMsg } from '@/utils/message';
import { errorNotify } from '@/utils/errorNotification';
import { ElNotification } from 'element-plus';
import { i18n } from '@/Lang/index';
import { gatewayPermissionRequest } from '@/utils/serviceContext';

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.gateway - ゲートウェイのID
 * @return {Promise<string[]>} サービスIDのリスト
 */
export async function getGatewayServiceList(data) {
  let serviceList = [];
  try {
    const gatewayService = await gatewayPermissionRequest({
      url: '/gatewayservices',
      method: 'get',
      params: {
        gateway_id: data.gateway,
      },
    });
    if (gatewayService && Array.isArray(gatewayService.serviceList)) {
      serviceList = gatewayService.serviceList;
    }
  } catch {
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return serviceList;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string[]} data.gwIds - ゲートウェイのID
 * @return {Promise<object>} ゲートウェイごとのサービスIDのリストをもつオブジェクト
 */
export async function getGatewaysServiceList(data) {
  const serviceListObj = {};
  try {
    await Promise.allSettled(
      data.gwIds.map(async (gwId) => {
        const serviceList = await getGatewayServiceList({ gateway: gwId });
        serviceListObj[gwId] = serviceList;
      })
    );
  } catch {
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return serviceListObj;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.gatewayId - ゲートウェイのID
 * @return {Promise<Object>} ゲートウェイサービスのデータ
 */
export async function getGatewayService(data) {
  let res_gatewayService = null;
  try {
    const gatewayService = await gatewayPermissionRequest({
      url: '/gatewayservices',
      method: 'get',
      params: {
        gateway_id: data.gatewayId,
      },
    });
    res_gatewayService = gatewayService;
  } catch {
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res_gatewayService;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @return {Promise<string[]>} サービスIDのリスト
 */
export async function setGatewayService(data) {
  let res = { status: 0 };
  const setGatewayServiceFailedNotify = (data) => {
    ElNotification({
      title: i18n.global.t('gateway.error'),
      message: errorMsg.e_register_service_failed + `: ${data.gatewayId}`,
      type: 'error',
      duration: 2000,
      customClass: 'notify',
    });
  };
  try {
    await request({
      url: '/gatewayservices',
      method: 'post',
      params: {
        gateway_id: data.gatewayId,
      },
      data: {
        billToId: data.billToId,
        serviceList: data.serviceList,
      },
    });
  } catch {
    setGatewayServiceFailedNotify(data);
    res = { status: -2 };
  }
  return res;
}
